import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
//
import { selectAnnouncementList, selectIsIDCardPopupDismissed } from 'redux/selector/app'
//
import AdItem from './component/AdItem'
import SystemItem from './component/SystemItem'
//
import { AnnouncementType } from 'constant/announcement'
//
import { Wrapper } from './Styled'

interface AnnouncementEntry {
  id?: any
  _id?: string
  announcementType?: string
  [key: string]: any
}

/** 公告頁面(分為系統公告 和 彈窗廣告公告) */
export default function Announcement() {
  const announcementList = useSelector(selectAnnouncementList)
  const isSkippedAnnouncement = useSelector((state: any) => state.app.isSkippedAnnouncement)
  const isIDCardPopupDismissed = useSelector(selectIsIDCardPopupDismissed)

  const [announcement, setAnnouncement] = useState<AnnouncementEntry[]>([])
  const [currentDisplayAnnouncement, setCurrentDisplayAnnouncement] = useState<AnnouncementEntry>({})

  useEffect(() => {
    // 啟用跳過公告模式會不顯示公告與彈窗廣告
    if (isSkippedAnnouncement) return

    const list = announcementList?.map((entry: any) => {
      const announcementType = entry.type
      const info = entry.item

      return {
        ...info,
        id: info?.id,
        _id: `${announcementType}_${info?.id}`,
        announcementType,
      }
    })

    setAnnouncement(list)
    setCurrentDisplayAnnouncement(list[0])
  }, [announcementList, isSkippedAnnouncement])

  const handleCancel = (info: AnnouncementEntry) => {
    const list = announcement?.filter((el) => el._id !== info._id)
    setAnnouncement(list)
    setCurrentDisplayAnnouncement(list[0])
  }

  if (!isIDCardPopupDismissed) return null
  if (isEmpty(announcement)) return null

  const ChildComponent = currentDisplayAnnouncement?.announcementType === AnnouncementType.Ad ? AdItem : SystemItem

  return (
    <Wrapper>
      <ChildComponent
        {...currentDisplayAnnouncement}
        currentDisplayAnnouncement={currentDisplayAnnouncement}
        handleCancel={() => handleCancel(currentDisplayAnnouncement)}
      />
    </Wrapper>
  )
}
